/*=========================================================================================
  File Name: state.js
  Description: Phone Service Actions
  ----------------------------------------------------------------------------------------
  Item Name: Phone Service State Module
  Author: Tan Tran
==========================================================================================*/
import restaurantQueries from '../../../services/phoneService/queries'
import TimeFormatter from '../../../common/utils/TimeFormatter'
import productQueries from '../../../services/products/queries.js'
import categoryQueries from '../../../services/categories/queries.js'
import orderManagerQueries from '../../../services/ordermanager/queries'
import orderManagerCommands from '../../../services/ordermanager/commands'
import ErrorHandling from '../../../common/exceptions/ErrorHandling.js'
export default {

  async getAllRestaurantsAction( {commit, state, rootState }, payload ) {

    await restaurantQueries.getAllRestaurants()
                 .then( data => {
                  //console.log(data)
                   commit('SET_RESTAURANTS_STATE', data)
                 });
  },

  async getProductsAction ( { commit, state, rootState }, payload) { 
    let restaurantId = state.selectedRestaurantId;

    let token = rootState.auth.auth.token;
    let error = null;
    //console.log('action is call, id: ' + restaurantId);
    try {
        await productQueries.getProductsByRestaurant(restaurantId, token)
                .then(
                    res => {
                        commit('SET_PRODUCTS_STATE', res);
                        commit('SET_CATEGORIES_STATE', res);
                    });
    }
    catch (err) {
        error = ErrorHandling.getErrorType(err);
        console.log(error)
        commit('app/SET_EXCEPTION_STATE', error, { root : true });
    }
  },

  async getTaxesAction ( { commit, state, rootState }, payload) {

    let restaurantId = state.selectedRestaurantId;
    let token = rootState.auth.auth.token;
    let error = null;
    //console.log('action is call, id: ' + restaurantId);
    try {
        await productQueries.getTaxesByRestaurant(restaurantId, token)
                 .then(
                     res => {
                      //console.log(res)
                      commit('SET_TAXES_STATE', res);
                    })
    }
    catch (err) {
        error = ErrorHandling.getErrorType(err);
        commit('app/SET_EXCEPTION_STATE', error, { root : true });
    }
  },

  async getCategoriesAction ( { commit, state, rootState }, payload) {
    let restaurantId = state.selectedRestaurantId;
    let token = rootState.auth.auth.token;
    let error = null;
    //console.log('action is call, id: ' + restaurantId);
    try {
        await categoryQueries.getCategoriesByRestaurant(restaurantId, token)
                 .then(
                     res => {
                         commit('SET_CATEGORIES_STATE', res); 
                    });
    }
    catch (err) {
        error = ErrorHandling.getErrorType(err);
        commit('app/SET_EXCEPTION_STATE', error, { root : true });
    }
    
  },

  //
  //
  //
  async getCurrentOrdersAction( {commit, state, rootState }, payload ) {

    let restaurantId = payload.restaurantId;

    await orderManagerQueries.getCurrentOrders(restaurantId)
                 .then( data => {
                   commit('SET_CURRENTORDERS_STATE', data)
                 });
  },

  async getCurrentWaitingTimeAction( {commit, state, rootState }, payload ) {

    let restaurantId = state.selectedRestaurantId;

    await orderManagerQueries.getCurrentWaitingTime(restaurantId)
                 .then( data => {
                   commit('SET_CURRENT_WAITING_TIME_STATE', data)
                 });
  },  

  async getOrderManagerStateAction ({commit, state, rootState }, payload) {
    
    let restaurantId = state.selectedRestaurantId;
    await orderManagerQueries.getOrderManagerState(restaurantId)
                .then( data => {
                  //console.log(data)
                  commit('SET_ORDER_MANAGER_STATE', data)
                });
  },



}